import React, { Fragment } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { narrativeElements, storytellingBeats } from '../data/abbviePro';
export function StorytellingScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-presentation-canvas px-6 py-20" aria-labelledby="storytelling-title" data-id="element-354" data-mp="181p7nw5wap0w">
      <div className="mx-auto w-full max-w-7xl" data-id="element-355" data-mp="1mxog57wx2r6k">
        <p className="mb-4 text-sm font-semibold text-primary" data-id="element-356" data-mp="1mwdcd83h1jfg">08 - Storytelling &amp; content framework</p>
        <h2 id="storytelling-title" className="max-w-2xl text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-357" data-mp="1vr0cppua35ku">
          Hollywood structure, scientific integrity
        </h2>

        <div className="mt-14 flex flex-col gap-2 lg:flex-row lg:items-stretch" data-id="element-358" data-mp="1rrsmpq29sx74">
          {storytellingBeats.map((beat, index) => <Fragment key={beat.beat} data-id="element-359" data-mp="20qmorvydefs2" data-mpi={index}>
              <motion.div initial={reduceMotion ? false : {
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.22,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex-1 rounded-2xl bg-abbvie-navy p-5 text-white" data-id="element-360" data-mp="20ro103r4h8bd">
                <span className="text-xs font-bold text-abbvie-cyan" data-id="element-361" data-mp="lyrbu7onttka">{String(index + 1).padStart(2, '0')}</span>
                <h3 className="mt-2 text-sm font-bold" data-id="element-362" data-mp="qw9jzvuus4r8">{beat.beat}</h3>
                <p className="mt-2 text-xs leading-relaxed text-white/60" data-id="element-363" data-mp="vv3zooxixd74">{beat.description}</p>
              </motion.div>
              {index < storytellingBeats.length - 1 && <ArrowRightIcon className="mx-auto hidden h-4 w-4 shrink-0 self-center text-slate-300 lg:block" aria-hidden="true" data-id="element-364" data-mp="15lfgvd67xivy" />}
            </Fragment>)}
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-3" data-id="element-365" data-mp="1em3w2b7clpaf">
          {narrativeElements.map((item, index) => <motion.div key={item.title} initial={reduceMotion ? false : {
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.22,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-slate-200 bg-white p-6" data-id="element-366" data-mp="3ap09fvmlmu7o" data-mpi={index}>
              <h3 className="font-bold text-abbvie-navy" data-id="element-367" data-mp="3uczjf49c9xc1">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500" data-id="element-368" data-mp="3ufbxh6bz7njt">{item.description}</p>
            </motion.div>)}
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-slate-500" data-id="element-369" data-mp="77qgtmqf94lm">
          Complex scientific data is distilled into easily consumed formats - helping brand managers earn the right to a deeper scientific conversation, never oversimplifying the evidence itself.
        </p>
      </div>
    </section>;
}